import { Component, Input } from '@angular/core'
import { HelperService } from '../../../../../services/helper.service'
import { IDataCardFGD } from '../../../../../models/data-card.model'
import { NotificationsDataCardModalComponent } from '../../cmms-components/notifications-data-card-modal/notifications-data-card-modal.component'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'app-data-flame-gas',
    templateUrl: './data-flame-gas.component.html',
    standalone: false
})
export class DataFlameGasComponent {
  @Input() data: IDataCardFGD
  @Input() filter?: {startTime?: string; endTime?: string}
  @Input() hasCMMSPackage: boolean = false
  @Input() hasRCAFPackage: boolean = false

  constructor(private modalService: NgbModal) {}

  public getSIFParams(mo: string): any {
    return {
      filter: JSON.stringify(
        HelperService.getObjectWithoutNullValues({
          initiator: mo,
        }),
      ),
    }
  }

  public hasUrlBadges(): boolean {
    return !!(
      this.data &&
      (this.data.Dev_Active ||
        this.data.Dev_InActive_Count ||
        this.data.Flt_Active ||
        this.data.Flt_InActive_Count ||
        this.data.Dmd_Active ||
        this.data.Dmd_InActive_Count ||
        this.data.Ovr_Active ||
        this.data.Ovr_InActive_Count)
    )
  }

  public onOpenNotificationModal(tag: string): void {
    const modalRef = this.modalService.open(NotificationsDataCardModalComponent, {
      windowClass: 'cmms-notification-modal-z2000',
      backdropClass: 'cmms-notification-backdrop-z2000',
    })
    modalRef.componentInstance.mainObject = tag
  }

  public displayNotificationIcon(notificationStatus?: number): boolean {
    return this.hasCMMSPackage && (notificationStatus === -1 || notificationStatus === 1)
  }

  public getChartData(): any {
    return {
      dates: [
        '12.2021',
        '1.2022',
        '2.2022',
        '3.2022',
        '4.2022',
        '5.2022',
        '6.2022',
        '7.2022',
        '8.2022',
        '9.2022',
        '10.2022',
        '11.2022',
      ],
      totals: [3, 0, 7, 1, 2, 0, 0, 7, 0, 0, 0, 0],
      x_axis: [
        'Dec. 21',
        'Jan. 22',
        'Feb. 22',
        'Mar. 22',
        'Apr. 22',
        'May. 22',
        'Jun. 22',
        'Jul. 22',
        'Aug. 22',
        'Sep. 22',
        'Oct. 22',
        'Nov. 22',
      ],
    }
  }
}
